<template>
  <div class="container py-5">

    <p>
    <b> TSK Workshop｜2026 AMWC Asia-TDAC </b>
    <br>誠摯邀請您參與由 TSK Taiwan 主辦 2026 AMWC Asia-TDAC 工作坊，匯聚國內頂尖醫師，分享最新醫美注射技術與臨床經驗，深入探討安全性與精準度兼具的治療策略。
    <br><br>日期｜ 2026/5/2(六)<br>時間｜ 12:30 – 13:30<br>地點｜ 台北國際會議中心（TICC）三樓北軒（North Lounge – Level 3）
    <br><br><b>講師陣容</b>
<br><b>Moderator｜張長正 醫師（CHANG Chang-Cheng, MD PH.D FACS）</b>
<br><br><b>Speaker｜梁仲斌 醫師（Liang,Ben,Chung-Pin, MD）</b>
<br>講題： Cannula Injection Revisited: Six Principles for Safer and More Predictable Facial Rejuvenation
<br>重新探討鈍針注射六大原則，提升臉部年輕化療程的安全性與可預測性。
<br><br><b>Speaker｜楊仕安 醫師（YANG Shih-An, MD）</b>
<br>講題： From Precise Injection to Optimal Outcomes: Device Selection Strategies in Aesthetic Practice
<br>從精準注射到最佳療效：醫美臨床中的器械選擇策略。

<br><br><b>參加 TSK 工作坊即可獲得 價值千元專屬禮盒</b>

<br><br><b>TSK 攤位資訊</b>
<br><b>1 樓 Booth A23</b>
<br><b>4 樓 Booth D53</b>
<br><br>誠摯邀請各位醫師與醫美專業人士蒞臨參與，掌握最新臨床趨勢，體驗 TSK 精準工藝所帶來的專業價值。
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_61.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
